import ingealimentosApi from '../../services/ingealimentosApi'

export const login = data => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.post('/auth/login', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const logout = () => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.post('/auth/logout')
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)